import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener, OnDestroy, ViewChild, inject, output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { ENTRA_AUTH_CONFIG } from '../../../core/auth/entra-auth.config';
import { EntraAuthService } from '../../../core/auth/entra-auth.service';

@Component({
  selector: 'mkzs-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  protected readonly authConfig = inject(ENTRA_AUTH_CONFIG);
  protected readonly authService = inject(EntraAuthService);
  protected readonly authEnabled = this.authConfig.enabled;

  private readonly document = inject(DOCUMENT);
  private resizeObserver: ResizeObserver | undefined;

  @ViewChild('headerEl') private headerEl!: ElementRef<HTMLElement>;

  readonly signInRequested = output<void>();
  readonly signOutRequested = output<void>();

  protected mobileOpen = false;
  protected isScrolled = false;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
      this.document.documentElement.style.setProperty('--header-height', `${height}px`);
    });
    this.resizeObserver.observe(this.headerEl.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  protected toggleMobile(): void {
    this.mobileOpen = !this.mobileOpen;
  }

  protected closeMobile(): void {
    this.mobileOpen = false;
  }

  @HostListener('window:scroll')
  protected onWindowScroll(): void {
    this.isScrolled = window.scrollY > 24;
  }
}
